import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import UpdateIcon from "../../Common/svg/updateicon.jsx";
import { useQuery } from "react-query";
import { getStores } from "../../../MyApi/stores/index.js";
import SearchInput from "./searchInput.jsx";
import DateFilter from "./dateFilter.jsx";
import ReviewStatus from "./reviewStatus.jsx";
import RatingsFilter from "./ratingsfilter.jsx";
import CategoriesFilter from "./categoriesFilter.jsx";
import EnhancedSearchStore from "../enhancedstoresearch/index.jsx";
import CityFilter from "./countryFilter.jsx";
import OrderStatusFilter from "./orderStatusFilter.jsx";
import DateRangeFilter from "../daterange/index.jsx";
import CompanyFilter from "./companyFilter.jsx";
import CourierStatusFilter from "./courierStatusFilter.jsx";
import ShippingStatusFilter from "./shippingStatusFilter.jsx";

const FilterBar = ({
  onFilterChange,
  filters,
  setFilters,
  filtersConfig,
  placeholder,
  onResetFilters
}) => {
console.log('FilterBarComponentRender')
  const hasFilter = (name) => !!filtersConfig[name];

  const handleChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
  
  };
  
  const setStoreId =(id)=>{
    handleChange("store_id", id)
  }

  const handleResetFilters = () => {
    const resetFilters = {
      search: "",
      store_id: "",
      role: "",
      city: "",
      category_id: "",   
      date: "",
      order_status: "",
      is_active: "",
      company: "",
      status: ""
    };
    setFilters(resetFilters);

  };

  return (
    <Form className="border rounded-4 p-2 bg-white mb-4 p-4 ">
      <Row className="g-2 d-flex justify-content-between  filter     align-items-center flex-wrap">
        <Col md="6">
          {hasFilter("search") && (
            <SearchInput handleChange={handleChange} filters={filters}  placeholder={placeholder}/>
          )}
        </Col>
        <div className="col-md-6 add">
          <div className="row justify-content-end align-items-center">
            {hasFilter("store") && (
              <Col xs="auto">
                <EnhancedSearchStore setStoreId={setStoreId}/>
              </Col>
            )}
            {hasFilter("role") && (
              <Col xs="auto">
                <Form.Select
                  value={filters.role}
                  onChange={(e) => handleChange("role", e.target.value)}
                >
                  <option value="">الدور</option>
                </Form.Select>
              </Col>
            )}
            {hasFilter("city") && <CityFilter filters={filters} handleChange={handleChange}/>}
            {hasFilter("categories") && <CategoriesFilter filters={filters} handleChange={handleChange}/>}
            {hasFilter("date") && <DateFilter filters={filters} handleChange={handleChange}/>}
            {hasFilter("order_status") && <OrderStatusFilter filters={filters} handleChange={handleChange}/>}
            {hasFilter("reviewStatus") && <ReviewStatus />}
            {hasFilter("date_range") && <DateRangeFilter filters={filters} setFilters={setFilters}/>}
            {hasFilter("rating") && <RatingsFilter />}
            {hasFilter("company") && <CompanyFilter filters={filters} handleChange={handleChange}/>}
            {hasFilter("status") && <CourierStatusFilter filters={filters} handleChange={handleChange}/>}
{hasFilter("is_active") && (
  <ShippingStatusFilter
    filters={filters}
    handleChange={handleChange}
    filterKey={filtersConfig.is_active !== true ? filtersConfig.is_active : "is_active"}
    options={filtersConfig.statusOptions}
  />
)}            <Col xs="auto">
              <Button 
                variant="primary" 
                className="btn-primary "
                onClick={handleResetFilters}
              >
                <span className="me-2"> <UpdateIcon  color="#fff" /></span>
                إعادة تعيين الفلتر
              </Button>
            </Col>
          </div>
        </div>
      </Row>
    </Form>
  );
};

export default FilterBar;
